<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>营销</el-breadcrumb-item>
            <el-breadcrumb-item>优惠券</el-breadcrumb-item>
            <el-breadcrumb-item>领取记录</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="dis-flex">
            <div class="second-swaper">
                <second></second>
            </div>
            <div class="flex-box">
                <Table
                        :columns="columns"
                        :data="lists"
                        class="mt25"
                        ref="table"
                        highlight-row
                        :loading="loading"
                        no-userFrom-text="暂无数据"
                        no-filtered-userFrom-text="暂无筛选结果"
                        @on-selection-change="onSelectTab">
                    <template slot-scope="{ row, index }" slot="logo">
                        <viewer>
                            <div class="tabBox_img">
                                <img v-lazy="row.logo"/>
                            </div>
                        </viewer>
                    </template>
                    <template slot-scope="{ row, index }" slot="coupon_type">
                        <div class="acea-row">
                            <div v-text="row.coupon_type == 10 ? '满减券' : '折扣券'"></div>
                        </div>
                    </template>
                    <template slot-scope="{ row, index }" slot="reduce_price">
                        <div class="acea-row">
                            <div v-text="row.coupon_type == 10 ? '立减'+row.reduce_price+'元' : '打'+row.discount+'折'"></div>
                        </div>
                    </template>
                    <template slot-scope="{ row, index }" slot="state_text">
                        <div>
                            {{row.state.text}}
                        </div>
                    </template>
                    <template slot-scope="{ row, index }" slot="end_time">
                        <div>
                            {{row.end_time}}
                        </div>
                    </template>
                    <template slot-scope="{ row, index }" slot="action">
                        <a @click="edit(row)">编辑</a>
                        <Divider type="vertical"/>
                        <a @click="del(row)">删除</a>
                        <Divider type="vertical"/>
                    </template>
                </Table>
                <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
                               :current-page.sync="pageNum" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
                               layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import second from "../second.vue";

    export default {
        name: 'index',
        components: { second },
        data() {
            return {
                columns: [
                    {
                        title: "ID",
                        key: "user_coupon_id",
                        width: 80,
                    },
                    {
                        title: "优惠券名称",
                        key: "name",
                        minWidth: 150,
                    },
                    {
                        title: "优惠券类型",
                        slot: "coupon_type",
                        minWidth: 100,
                    },
                    {
                        title: "最低消费金额 (元)",
                        key: "min_price",
                        minWidth: 150,
                    },
                    {
                        title: "优惠方式",
                        slot: "reduce_price",
                        minWidth: 100,
                    },
                    {
                        title: "状态",
                        align: 'center',
                        slot: "state_text",
                        minWidth: 100,
                    },
                    {
                        title: "有效期",
                        align: 'center',
                        slot: "end_time",
                        minWidth: 100,
                    },
                    {
                        title: "领取时间",
                        key: "create_time",
                        minWidth: 100,
                    },
                ],
                lists: [],
                isLoad: false,
                // 每页多少条数据
                pageNum: 0,
                pageSize: 20,
                total: 0,
                // 当前在第几页
                page: 1,
            }
        },
        created() {
            this.loadList()
        },
        methods: {
            sizeReload(val) {
                this.item.pageSize = val
                this.loadList()
            },
            pageReload(val) {
                this.item.page = val
                this.loadList()
            },
            loadList() {
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.post('/store/app.coupon/receiveList', {
                    page: this.page,
                    pagesize: this.pageSize
                })
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 获取数据
                        this.lists = res.data.list.data
                        this.total = res.data.list.total
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            // 跳转到edit添加
            add() {
                this.$router.push({path: '/app/coupon/add.html'});
            },
            // 传一个ID跳转到edit页面，进行编辑
            edit(row) {
                this.$router.push({
                    path: '/app/coupon/add.html',
                    query: {
                        id: row.coupon_id
                    }
                });
            },
            del (row) {
                this.$Modal.confirm({
                    title: '删除',
                    content: '<p>确定要删除数据吗？</p><p>删除后将无法恢复，请谨慎操作！</p>',
                    loading: true,
                    onOk: () => {
                        this.axios.post('/store/app.coupon/delete', {
                            coupon_id: row.coupon_id
                        })
                            .then(async (res) => {
                                if (res.code == 1) {
                                    this.$Modal.remove();
                                    this.loadList()
                                } else {
                                    this.$Message.error(res.msg);
                                    this.$Modal.remove();
                                }
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    }
                })
            },
        }
    }
</script>
<style scoped>
</style>
